<template>
  <div>
    <Head title="Job Reports" />
    <h1 class="mb-8 text-3xl font-bold">
      Job Reports
      <downloadexcel :data="jobs" :fields="job_fields">
        <v-btn large color="primary">Download <v-icon>mdi-download</v-icon></v-btn>
      </downloadexcel>
    </h1>

    <v-data-table :items="jobs" :headers="headers">
      <template v-slot:item.job_posted_date="{ item }">
        {{ formatDate(item.job_posted_date) }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue'
import { Link } from '@inertiajs/inertia-vue'
import Layout from '@/Shared/VuetifyAdminLayout'
import downloadexcel from "vue-json-excel";

export default {
  components: {
    Head,
    downloadexcel,
    Link
  },
  props: {
    jobs: Array
  },
  data: () => ({
    headers: [
      { text: 'Job ID', value: 'job_id' },
      { text: 'Organisation', value: 'organisation' },
      { text: 'Job Title', value: 'job_title' },
      { text: 'Hits', value: 'hits' },
      { text: 'Apply Now', value: 'apply_now' },
      { text: 'User Email', value: 'user_email' },
      { text: 'User Gender', value: 'user_gender' },
      { text: 'Job Posted Date', value: 'job_posted_date' },
    ],
    job_fields: {
      "Job ID": "job_id",
      "Job Title": "job_title",
      "Hits": "hits",
      "Apply Now": "apply_now",
      "User Email": "user_email",
      "User Gender": "user_gender",
      "Organisation": "organisation",
      "Job Posted Date": "job_posted_date",
    },
  }),
  layout: Layout,
  methods: {
    formatDate(date) {
      if (!date) return '';
      return new Date(date).toLocaleDateString();
    }
  }
}
</script>

<style scoped>
.v-sheet--offset {
  top: -24px;
  position: relative;
}
</style>